import { defaults, filter  } from 'lodash';

export default class AssetService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    Upload,
    utils
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.Upload = Upload;
    this.utils = utils;
  }

  uploadAsset(accountId, file, fileName, fileType, isPublic, links) {
    var url = this.#serviceBaseUrl(accountId);

    return this.Upload.upload({
      url: url,
      method: 'POST',
      data: {
        asset: this.Upload.json({
          fileName: fileName,
          fileType: fileType,
          isPublic: !!isPublic,
          links: links || []
        }),
        file: file
      }
    }).then(function (response) {
      return response.data;
    }).catch(this.utils.errorHandler);
  }

  deleteAsset(accountId, assetId) {
    var url = this.#serviceBaseUrl(accountId, assetId);
    return this.$http.delete(url);
  }

  getAssets(accountId, fileType, isPublic) {
    var url = this.#serviceBaseUrl(accountId);
    return this.$http.get(url)
      .then(function (result) {
        var filterResult = false;
        if (typeof fileType === 'string' && fileType.length) {
          filterResult = { fileType: fileType };
        }
        if (typeof isPublic === 'boolean') {
          filterResult = defaults({}, filterResult, { isPublic: isPublic });
        }
        if (filterResult) {
          return filter(result.data.fileAssets, filterResult);
        }
        return result.data.fileAssets;
      }).catch(this.utils.errorHandler);
  }

  getAssetReferences(accountId, assetId) {
    var url = this.#serviceBaseUrl(accountId, assetId);
    return this.$http.get(url + '/InboundReferences');
  }

  
  #serviceBaseUrl(accountId, assetId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/assets/'  + (assetId ? '/' + assetId : '');
  }
}